// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3Hh7I","list":"BalanceDue_list__b2ik6","listRow":"BalanceDue_listRow__21NZC","total":"BalanceDue_total__zpBkZ"};